import { colors2 } from "oolib";

// Tunable knobs for the Signals widget. Keep widget-specific thresholds + styling
// here so they're easy to find + tweak without digging through the assembly logic.
export const CONFIG = {
  // ±% change vs the previous period before a signal reads rising/declining
  // (else stable). 20 = v1 parity (trendCalculator.TREND_THRESHOLD_PCT).
  trendThresholdPct: 20,
  // How many co-occurring topics to show per signal.
  topCooccurringTopics: 4,

  // Per signal-category styling: the badge colour + the trend tone.
  //   tone: "good"  → rising is green (e.g. satisfaction)
  //         "bad"   → rising is red   (e.g. dissatisfaction)
  //         "neutral" → grey, like Topics (direction is informational)
  // Mirrors v1 BADGE_COLORS. NOTE: v1 coloured every non-dissatisfaction signal's
  // rising as green; here needs/behaviour are "neutral" instead — a rising
  // "Feature Request" or "Habit" isn't inherently good or bad. Flip to "good"
  // if you want exact v1 behaviour.
  // badgeBg = the category's base colour, flat (SIGNAL_CATEGORY_ACCENT in
  // analysisModules/comps/SignalFilters/signalCategories.js), white text on it.
  categoryStyle: {
    userDissatisfaction: { badgeBg: "#D4553A", badgeColor: colors2.white, tone: "bad" },
    userSatisfaction: { badgeBg: "#2FA075", badgeColor: colors2.white, tone: "good" },
    userNeeds: { badgeBg: "#8F55B3", badgeColor: colors2.white, tone: "neutral" },
    userBehaviour: { badgeBg: "#D9A02A", badgeColor: colors2.white, tone: "neutral" },
  },
  defaultCategoryStyle: { badgeBg: colors2.grey40, badgeColor: colors2.grey80, tone: "neutral" },
};
